/**
 * FanStandManager - Sistema de addon Fan Stand para Shopify
 * VISO Project - Independiente del AddonManager de inserts
 */
const FanStandManager = (function() {
  'use strict';

  const CONFIG = {
    STORAGE_KEY: 'viso_fanstand_addons',
    ADDON_HANDLE: 'fan-stand',
    ADDON_VARIANT_ID: null,
    PROPERTY_KEY: 'Fan Stand',
    PROPERTY_VALUE: 'Included',
    FOR_PRODUCT_KEY: 'For Product (Fan Stand)',
   SELECTORS: {
      checkbox: '.addon-checkbox[data-addon-type="fanstand"]',
      container: '.addon-option[data-addon-type="fanstand"]',
      productSelect: '#product-select, [name="id"]',
      productForm: '#product-actions, form[action="/cart/add"]'
    }
  };

  const Storage = {
    get() {
      try {
        const data = localStorage.getItem(CONFIG.STORAGE_KEY);
        return data ? JSON.parse(data) : {};
      } catch (e) { return {}; }
    },
    set(data) {
      try { localStorage.setItem(CONFIG.STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
    },
    addAddon(pv, av) { const a = this.get(); a[pv] = av; this.set(a); },
    removeAddon(pv) { const a = this.get(); delete a[pv]; this.set(a); },
    hasAddon(pv) { return !!this.get()[pv]; }
  };

  const CartAPI = {
    async getCart() { return (await fetch('/cart.js')).json(); },
    async addItems(items) {
      return (await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })).json();
    },
    async updateByKey(key, quantity) {
      return (await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      })).json();
    },
    findItemWithProperty(cart, variantId, key, value) {
      return cart.items.find(i => i.variant_id === variantId && i.properties && i.properties[key] === value);
    }
  };

  const ProductPage = {
    init() {
      const checkboxes = document.querySelectorAll(CONFIG.SELECTORS.checkbox);
      if (!checkboxes.length) return;
      checkboxes.forEach(cb => this.restoreState(cb));
      this.interceptAddToCart();
    },
    getCurrentVariantId() {
      const s = document.querySelector(CONFIG.SELECTORS.productSelect);
      return s ? s.value : null;
    },
    restoreState(checkbox) {
      const container = checkbox.closest(CONFIG.SELECTORS.container);
      const pv = this.getCurrentVariantId() || container.dataset.productVariantId;
      container.dataset.productVariantId = pv;
      if (Storage.hasAddon(pv)) checkbox.checked = true;
    },
    interceptAddToCart() {
      const form = document.querySelector(CONFIG.SELECTORS.productForm);
      const button = document.querySelector('#add-to-cart');
      if (!form || !button) return;
      let isProcessing = false;

      button.addEventListener('click', async (e) => {
        const checkbox = document.querySelector(CONFIG.SELECTORS.checkbox);
        if (!checkbox || !checkbox.checked) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (isProcessing) return;
        isProcessing = true;

        try {
          const container = checkbox.closest(CONFIG.SELECTORS.container);
          const productVariantId = parseInt(this.getCurrentVariantId() || container.dataset.productVariantId, 10);
          const addonVariantId = parseInt(container.dataset.addonVariantId, 10);
          const qty = Math.max(1, parseInt(document.getElementById('quantity')?.value, 10) || 1);

          const productTitle = document.querySelector('.product-title, h1')?.textContent?.trim() || 'Product';
          const variantSelect = document.querySelector(CONFIG.SELECTORS.productSelect);
          let variantTitle = variantSelect?.options[variantSelect.selectedIndex]?.text || '';
          if (variantTitle.toUpperCase() === 'DEFAULT TITLE') variantTitle = '';
          const productInfo = variantTitle ? `${productTitle} - ${variantTitle}` : productTitle;

          const cart = await CartAPI.getCart();
          const existingMain = CartAPI.findItemWithProperty(cart, productVariantId, CONFIG.PROPERTY_KEY, CONFIG.PROPERTY_VALUE);
          const existingAddon = CartAPI.findItemWithProperty(cart, addonVariantId, CONFIG.FOR_PRODUCT_KEY, productInfo);

          if (existingMain && existingAddon) {
            await CartAPI.updateByKey(existingMain.key, existingMain.quantity + qty);
            await CartAPI.updateByKey(existingAddon.key, existingAddon.quantity + qty);
          } else {
            await CartAPI.addItems([
              { id: productVariantId, quantity: qty, properties: { [CONFIG.PROPERTY_KEY]: CONFIG.PROPERTY_VALUE } },
              { id: addonVariantId, quantity: qty, properties: { [CONFIG.FOR_PRODUCT_KEY]: productInfo } }
            ]);
          }
          Storage.addAddon(productVariantId, addonVariantId);

          // Mostrar modal de éxito (antes redirigía a /cart)
          this.showAddedToCart(qty, productTitle, productVariantId, container);
        } catch (error) {
          console.error('FanStandManager: Error', error);
          // Fallback en caso de error: ir al carrito
          window.location.href = '/cart';
        } finally {
          isProcessing = false;
        }
      }, true);
      // Backup: interceptar también el submit del form cuando el stand está marcado
      form.addEventListener('submit', (e) => {
        const checkbox = document.querySelector(CONFIG.SELECTORS.checkbox);
        if (checkbox && checkbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          // El click handler ya gestionó el añadido y el modal
        }
      }, true);
    },

    showAddedToCart(qty, productTitle, productVariantId, container) {
      // Usar la función central del modal si existe
      if (typeof window.showCartModal === 'function') {
        try {
          const productImage = document.querySelector('.product-gallery-slider img')?.src || null;

          const addonTitle = container ? (container.dataset.addonTitle || 'Fan stand') : 'Fan stand';
          const addonPrice = container ? (parseInt(container.dataset.addonPrice, 10) || 0) : 0;

          let unitPrice = 0;
          if (typeof window.visoVariantPrice === 'function') {
            unitPrice = window.visoVariantPrice(productVariantId) || 0;
          }

          const total = (unitPrice + addonPrice) * qty;

          window.showCartModal({
            qty: qty,
            productTitle: productTitle,
            addonTitle: addonTitle,
            total: total,
            image: productImage
          });
          return;
        } catch (e) {
          console.error('FanStandManager: showCartModal error', e);
        }
      }

      // Fallback: si no existe la función central, ir al carrito
      window.location.href = '/cart';
    }
  };

  const CartPage = {
    addonVariantId: null,
    isSyncing: false,
    async init() {
      await this.fetchAddonVariantId();
      await this.syncQuantities();
      //this.hideAddonItems();
    },
    async fetchAddonVariantId() {
      try {
        const p = await (await fetch(`/products/${CONFIG.ADDON_HANDLE}.js`)).json();
        this.addonVariantId = p.variants[0].id;
      } catch (e) {}
    },
    hideAddonItems() {
      // Desactivado: el stand se muestra como línea propia en el carrito
    },
    async syncQuantities() {
      if (this.isSyncing) return;
      this.isSyncing = true;
      try {
        const cart = await CartAPI.getCart();
        const updates = {};
        const mainsWithAddon = cart.items.filter(i => i.properties && i.properties[CONFIG.PROPERTY_KEY] === CONFIG.PROPERTY_VALUE);
        const addons = cart.items.filter(i => i.handle === CONFIG.ADDON_HANDLE || i.product_handle === CONFIG.ADDON_HANDLE || i.variant_id === this.addonVariantId);

        for (const main of mainsWithAddon) {
          const vt = main.variant_title && main.variant_title.toUpperCase() !== 'DEFAULT TITLE' ? main.variant_title : '';
          const productInfo = vt ? main.product_title + ' - ' + vt : main.product_title;
          const match = addons.find(a => a.properties && a.properties[CONFIG.FOR_PRODUCT_KEY] === productInfo);
          if (match && main.quantity !== match.quantity) updates[match.key] = main.quantity;
        }

        for (const addon of addons) {
          const forProduct = addon.properties && addon.properties[CONFIG.FOR_PRODUCT_KEY];
          if (forProduct) {
            const hasMain = mainsWithAddon.some(main => {
              const vt = main.variant_title && main.variant_title.toUpperCase() !== 'DEFAULT TITLE' ? main.variant_title : '';
              const productInfo = vt ? main.product_title + ' - ' + vt : main.product_title;
              return productInfo === forProduct;
            });
            if (!hasMain) updates[addon.key] = 0;
          } else {
            updates[addon.key] = 0;
          }
        }

        if (Object.keys(updates).length > 0) {
          for (const [key, quantity] of Object.entries(updates)) {
            await CartAPI.updateByKey(key, quantity);
          }
          window.location.reload();
        }
      } catch (error) {
        console.error('FanStandManager: Sync error', error);
      } finally {
        this.isSyncing = false;
      }
    }
  };

  function init() {
    if (document.querySelector(CONFIG.SELECTORS.container)) ProductPage.init();
    if (window.location.pathname === '/cart') CartPage.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return { Storage, CartAPI, ProductPage, CartPage, init };
})();
